import { Button as ButtonComponent } from "@sunwing/components/dist/Button";
import { RCL } from "../../components/RCL";

import config from "../../app/config";
import { StringResources } from "../../components/StringResources";

let styles;

(async () => {
  if (config.isWestJetMode) {
    styles = await import("./PlatinumClubVwq.module.scss");
  } else {
    styles = await import("./PlatinumClub.module.scss");
  }
})();

const PlatinumClubCtas = () => {
  return (
    <div className={styles.PlatinumClubCtaButtons}>
        <ButtonComponent
          outline
          className={styles.PlatinumClubButton}
          size={config.isWestJetMode ? "": "lg"}
          icon="arrow-right"
          iconPlacement="right"
          to={ StringResources({searchKey: "swg-platinum-club-learn-more"})}
          target="_blank"
        >
          <RCL searchKey="svg-learn-more" />
        </ButtonComponent>
    </div>
  )
}

export default PlatinumClubCtas;
export { PlatinumClubCtas };